exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes TemplateContent_fadeIn__2nDQ3 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes TemplateContent_fadeIn__2nDQ3 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes TemplateContent_fadeOut__1btR6 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes TemplateContent_fadeOut__1btR6 {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.TemplateContent_templateContent__3DDD2 {\n  display: -webkit-flex;\n  display: flex; }\n  .TemplateContent_templateContent__3DDD2 .TemplateContent_icon__29e4B {\n    width: 135px;\n    height: 76px;\n    -webkit-flex-shrink: 0;\n            flex-shrink: 0;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center; }\n  .TemplateContent_templateContent__3DDD2 .TemplateContent_info__kk96A {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-flex-direction: column;\n            flex-direction: column;\n    -webkit-flex-grow: 1;\n            flex-grow: 1;\n    overflow: hidden;\n    margin-left: 5px; }\n    .TemplateContent_templateContent__3DDD2 .TemplateContent_info__kk96A > * {\n      display: inline-block;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin: 0; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"templateContent": "TemplateContent_templateContent__3DDD2",
	"icon": "TemplateContent_icon__29e4B",
	"info": "TemplateContent_info__kk96A",
	"fadeIn": "TemplateContent_fadeIn__2nDQ3",
	"fadeOut": "TemplateContent_fadeOut__1btR6"
};